import { Box, TextField } from '@mui/material'
import { useRecurrencePeriodProps } from './useRecurrencePeriodProps'

export function RecurrencePeriod() {
  const props = useRecurrencePeriodProps()

  return (
    <Box data-testid="RecurrencePeriod" width="50%">
      <TextField {...props} />
    </Box>
  )
}
